import { CoachModal } from '@/features/coach/components/CoachModal';
import { useEffect, useState } from 'react';
import { FeedbackConversationPanel, type FeedbackConversationEditEntry } from '@/features/feedback-conversation/FeedbackConversationPanel';
import { feedbackConversationAuthorityFingerprint } from '@/lib/api';
import type { FeedbackConversationScope, FeedbackConversationTarget } from '@/lib/types';
import { useCanonicalScope } from './useCanonicalFeedback';

type Entry = { key: string; scope: FeedbackConversationScope; target: FeedbackConversationTarget };
/** Route disclosure and editing overlays do not own or recreate conversation writing. */
export function FeedbackConversationHost({ view, target, players = [], invalid = false, suspended = false, onClose, onEdit }: {
  view: 'coach'|'recipient'; target: FeedbackConversationTarget | null; invalid?: boolean; suspended?: boolean;
  players?: readonly { id: string; display_name: string }[];
  onClose(): void; onEdit?(entry: FeedbackConversationEditEntry): void;
}) {
  const scope = useCanonicalScope(view), [entries,setEntries] = useState<Entry[]>([]);
  const key = scope && target ? JSON.stringify([scope, feedbackConversationAuthorityFingerprint(), target]) : null;
  useEffect(() => {
    if (scope && target && key) setEntries(old => old.some(entry=>entry.key===key) ? old : [...old,{key,scope,target}]);
    // Identity includes the entire exact scope and private target.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return <>{invalid && !suspended && <CoachModal title="Feedback unavailable" onClose={onClose}><p>This destination does not identify an available Feedback conversation. Close it and choose an authorized Feedback item.</p></CoachModal>}{entries.map(entry=><FeedbackConversationPanel key={entry.key} scope={entry.scope} target={entry.target}
    active={entry.key===key&&!suspended} visible={entry.key===key&&!suspended} playerLabel={players.find(player=>player.id===entry.target.playerId)?.display_name} onClose={onClose} onEdit={onEdit} />)}</>;
}
